import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { SearchAggregationTimeUnit } from 'shared/domains/apollo/generated/types';
import { Select, TextField } from 'shared/domains/forms';
export function RangeOffset(props) {
    const { name } = props;
    const timeUnits = [
        {
            value: SearchAggregationTimeUnit.Day,
            label: t({ message: 'Day', comment: 'Insights widget form: Day' }),
        },
        {
            value: SearchAggregationTimeUnit.Week,
            label: t({ message: 'Week', comment: 'Insights widget form: Week' }),
        },
        {
            value: SearchAggregationTimeUnit.Month,
            label: t({ message: 'Month', comment: 'Insights widget form: Month' }),
        },
        {
            value: SearchAggregationTimeUnit.Year,
            label: t({ message: 'Year', comment: 'Insights widget form: Year' }),
        },
    ];
    return (<Fragment>
      <Select name={`${name}.roundingTimeUnit`} label={t({
            message: 'Rounding time unit',
            comment: 'Insights widget form: Rounding time unit',
        })}>
        {timeUnits.map((unit) => (<option key={unit.value} value={unit.value}>
            {unit.label}
          </option>))}
      </Select>
      <Select name={`${name}.timeUnit`} label={t({ message: 'Time unit', comment: 'Insights widget form: Time unit' })}>
        {timeUnits.map((unit) => (<option key={unit.value} value={unit.value}>
            {unit.label}
          </option>))}
      </Select>
      <TextField name={`${name}.value`} label={t({ message: 'Value', comment: 'Insights widget form: Value' })} type="number"/>
    </Fragment>);
}
